export const INTEGRATOR_ID = 'audi:integrator:csr';
//# sourceMappingURL=constants.js.map